import http from './_http_v2'

// if(sessionStorage.token){
//     http.defaults.headers.Authorization = "Bearer " + sessionStorage.token;
// }

const PDF = (m) => { return http.post(`/common/pdf`, m, { responseType: 'arraybuffer' }); }

const pdf = { PDF }

export default pdf
export { PDF }
